import {mapState} from "vuex";

console.log('test main start');

import {Vue, globalOptions, globalData, globalMethods, globalCreated, globalMounted} from '@src/data.js'

import {router} from './routes'
//import Locale from './vue_components/Locale'
const Locale = () => import(/* webpackChunkName: "locale" */ './vue_components/Locale');
const callback = () => import(/* webpackChunkName: "callback" */ '@vueComponent/callback');
const modalOneClick = () => import(/* webpackChunkName: "modalOneClick" */ '@vueComponent/modalOneClick');
const search = () => import(/* webpackChunkName: "search" */ '@vueComponent/search-modal');

let optionslocal = {
    data() {
        return {
            ...globalData,
            menuActive: false,
            staticText: undefined,
            dataMain: undefined,
            keys: {37: 1, 38: 1, 39: 1, 40: 1},
            styleCursorLoad: 'translate3d(0,0,0)'
        }
    },
    router,
    computed: {
        // ...mapState('cart', ['localRent', 'localBuy']),
        ...mapState(['mobileState'])
    },
    components: {
        'cmp-locale': Locale,
        'callback': callback,
        'modal-one-click-cmp': modalOneClick,
        'search-modal': search
    },
    methods: {
        ...globalMethods,
        num2str(n, text_forms) {
            n = Math.abs(n) % 100;
            let n1 = n % 10;
            if (n > 10 && n < 20) { return text_forms[2]; }
            if (n1 > 1 && n1 < 5) { return text_forms[1]; }
            if (n1 === 1) { return text_forms[0]; }
            return text_forms[2];
        },
        menuToggleHandler() {
            const self = this; // ссылка на текущий объект чтобы не потерять контекст

            // Функция закрытия по внешнему клику
            const missClick = function missClick(event) {
                event.stopPropagation();

                self.missClickHandler(event.target, () => {
                    self.menuActive = false;
                    self.enableScroll();
                    document.removeEventListener('click', missClick);
                })
            };

            this.menuActive = !this.menuActive;

            if(this.menuActive) {
                this.$root.headerTop = false;
                this.disableScroll();
                document.addEventListener('click', missClick);

            } else {
                this.enableScroll();
                document.removeEventListener('click', missClick);
            }

            // если открываем меню на странице 404 и корзины
            if (this.$route.name === 'e404' && this.$root.whiteHeader) {
                this.$root.whiteHeader = false;
            } else if (this.$route.name === 'e404' && !this.$root.whiteHeader) {
                this.$root.whiteHeader = true;
            }

            if (this.$route.name === 'cart' && this.$root.wrong && this.$root.whiteHeader) {
                this.$root.whiteHeader = false;
            } else if (this.$route.name === 'cart' && this.$root.wrong && !this.$root.whiteHeader) {
                this.$root.whiteHeader = true;
            }
        },
        missClickHandler(target, f) {
            // Метод закрытия по внешнему клику
            // target - HTML элемент по которому произошел клик
            // f - функция которую необходимо выполнить если клик попадает по оверлею
            const overlay = this.$refs.overlay;
            if (target === overlay) return f();
        },
        closeMenu() {
            this.menuActive = false;
            this.enableScroll();
        },
        preventDefault(e) {
            e = e || window.event;
            if (e.preventDefault)
                e.preventDefault();
            e.returnValue = false;
        },
        preventDefaultForScrollKeys(e) {
            if (this.keys[e.keyCode]) {
                this.preventDefault(e);
                return false;
            }
        },
        disableScroll() {
            if (this.mobileState) {
                let body = document.querySelector('body');
                if (body.style.position !== "fixed") {
                    let heightScroll = window.pageYOffset;
                    body.style.cssText = "overflow-y: scroll; top: " + (-heightScroll) + "px; position: fixed;";
                }
            } else {
                if (window.addEventListener) // older FF
                    window.addEventListener('DOMMouseScroll', this.preventDefault, {passive : false});
                document.addEventListener('wheel', this.preventDefault, {passive: false}); // Disable scrolling in Chrome
                document.addEventListener('touchmove', this.preventDefault, {passive: false}); // mobile
                window.onwheel = this.preventDefault; // modern standard
                window.onmousewheel = document.onmousewheel = this.preventDefault; // older browsers, IE
                //window.ontouchmove  = preventDefault; // mobile
                document.onkeydown  = this.preventDefaultForScrollKeys;
            }
        },
        enableScroll() {
            if (this.mobileState) {
                let body = document.querySelector('body');
                let heightTop = body.style.top;
                body.style.cssText = "overflow-y: auto; top: auto; position: static;";

                window.scrollTo({
                    top: -parseInt(heightTop),
                    behavior: "instant"
                });
            } else {
                if (window.removeEventListener)
                    window.removeEventListener('DOMMouseScroll', this.preventDefault, {passive : false});
                document.removeEventListener('wheel', this.preventDefault, {passive: false}); // Enable scrolling in Chrome
                document.removeEventListener('touchmove', this.preventDefault, {passive: false}); // mobile
                window.onmousewheel = document.onmousewheel = null;
                window.onwheel = null;
                //window.ontouchmove = null;
                document.onkeydown = null;
            }
        }
    },
    created() {
        globalCreated(this);
        this.staticText = staticText;
        this.dataMain = dataMain;
    },
    mounted() {
        globalMounted(this);
    }
};

let options = Object.assign({}, globalOptions, optionslocal);
let vm = new Vue(options);




// WEBPACK FOOTER //
// ./src/main.js